<template>
    <div id="notification" v-if="text">
        <span>{{text}}</span>
    </div>
</template>

<script>
    export default {
        name: 'Notification',
        props: {
            text: String
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/styles/variables/variables';

    #notification {
        position: fixed;
        display: flex;
        z-index: 1000;
        left: 0;
        padding: 20px 30px;
        font-size: 1em;
        font-weight: 500;
        background: white;
        width: 100%;
        align-items: center;
        justify-content: center;
        height: 70px;
        bottom: 0;

        span {
            color: black;
        }

        @media all and (max-width: 800px) {
            bottom: 50px;
        }
    }
</style>
